// Canonical navigation icon vocabulary.
//
// Single source of truth for the emoji icons used by nav/sidebar config
// items (the Settings editor writes `icon` keys; TopNav + the Settings
// icon pickers render them). Previously copy-pasted in five files.
export const NAV_ICONS = [
  { key: 'home', emoji: '🏠', label: 'Home' },
  { key: 'folder', emoji: '📁', label: 'Folder' },
  { key: 'chart', emoji: '📊', label: 'Chart' },
  { key: 'clipboard', emoji: '📋', label: 'Clipboard' },
  { key: 'calendar', emoji: '📅', label: 'Calendar' },
  { key: 'globe', emoji: '🌐', label: 'Globe' },
  { key: 'link', emoji: '🔗', label: 'Link' },
  { key: 'email', emoji: '📧', label: 'Email' },
  { key: 'chat', emoji: '💬', label: 'Chat' },
  { key: 'briefcase', emoji: '💼', label: 'Business' },
  { key: 'building', emoji: '🏢', label: 'Building' },
  { key: 'people', emoji: '👥', label: 'People' },
  { key: 'person', emoji: '👤', label: 'Person' },
  { key: 'star', emoji: '⭐', label: 'Star' },
  { key: 'pin', emoji: '📌', label: 'Pin' },
  { key: 'bell', emoji: '🔔', label: 'Bell' },
  { key: 'search', emoji: '🔍', label: 'Search' },
  { key: 'tools', emoji: '🛠️', label: 'Tools' },
  { key: 'target', emoji: '🎯', label: 'Target' },
  { key: 'rocket', emoji: '🚀', label: 'Rocket' },
  { key: 'lightning', emoji: '⚡', label: 'Lightning' },
  { key: 'fire', emoji: '🔥', label: 'Fire' },
  { key: 'heart', emoji: '❤️', label: 'Heart' },
  { key: 'check', emoji: '✅', label: 'Check' },
  { key: 'warning', emoji: '⚠️', label: 'Warning' },
  { key: 'document', emoji: '📄', label: 'Document' },
  { key: 'package', emoji: '📦', label: 'Package' },
  { key: 'trending', emoji: '📈', label: 'Trending' },
  { key: 'lightbulb', emoji: '💡', label: 'Idea' },
  { key: 'money', emoji: '💰', label: 'Money' },
];

export const NAV_ICON_MAP = Object.fromEntries(NAV_ICONS.map(i => [i.key, i.emoji]));
